import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackUsage } from '../api/usage';

// Records every navigation of the signed-in user. Mount once in the
// authenticated layout. The ref de-duplicates re-renders and React StrictMode's
// double effect invocation, so one navigation is one event.
export function usePageTracking(): void {
  const { pathname } = useLocation();
  const lastTracked = useRef<string | null>(null);

  useEffect(() => {
    if (lastTracked.current === pathname) return;
    lastTracked.current = pathname;
    trackUsage(pathname);
  }, [pathname]);
}
